import { FC, useEffect } from "react";
import classNames from "classnames";
import { useHistory } from "react-router-dom";

import Icon from "@ant-design/icons";
import * as icons from "../../assets/customIcons";
import { observer } from "mobx-react-lite";
import menuStore from "../../store/menu";
import MenuList from "./MenuList";
import logoSmall from "../../assets/img/logo-small.png";

import styles from "./Menu.module.scss";

export const Menu: FC = observer(() => {
  const history = useHistory();
  const { menu, menuIsCollapsed, paramRowKeys: expandableKeys } = menuStore;

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      if (menuIsCollapsed.value) {
        expandableKeys.setKeys([]);
      }
    });

    return unlisten;
  }, []);

  const onHandlerScroll = () => {
    if (menuIsCollapsed.value) {
      expandableKeys.setKeys([]);
    }
  };

  useEffect(() => {
    expandableKeys.setKeys([]);
  }, [menuIsCollapsed.value]);

  return (
    <aside
      className={classNames(styles["menu"], {
        [styles["menu--collapsed"]]: menuIsCollapsed.value,
      })}
      onScroll={onHandlerScroll}
    >
      <div className={styles["menu__header-ico"]}>
        <img src={logoSmall} alt="logo" />
      </div>
      <MenuList menu={menu} level={0} expandableKeys={expandableKeys} />
      {!!expandableKeys.keys?.length && menuIsCollapsed.value && (
        <div
          data-overlay={true}
          className={styles["menu__overlay"]}
          onMouseEnter={(e) => {
            menuStore.setElementMouseOn(null);
            menuStore.isResetMenu.setTrue();
          }}
        />
      )}
    </aside>
  );
});
